// src/components/Logo.js
// Brand mark. Save the real logo to  frontend/public/karvi-logo.png  and it shows here.
// If the file is missing, it falls back to the gradient "Karvi AI" wordmark so nothing breaks.

import { useState } from "react";

export default function Logo({ size = 26, showText = true, onClick }) {
  const [imgOk, setImgOk] = useState(true);
  return (
    <div className="logo" onClick={onClick} role={onClick ? "button" : undefined}>
      {imgOk ? (
        <img
          className="logo__mark"
          src={`${process.env.PUBLIC_URL || ""}/karvi-logo.png`}
          alt="Karvi AI"
          style={{ height: size }}
          onError={() => setImgOk(false)}
        />
      ) : (
        // No logo file yet: badge when icon-only, wordmark when text is shown.
        !showText && (
          <span className="logo__badge" style={{ width: size + 8, height: size + 8, fontSize: (size + 8) * 0.42 }}>K</span>
        )
      )}
      {showText && (
        <span className="logo__text grad-text">
          Karvi<span>&nbsp;AI</span>
        </span>
      )}
    </div>
  );
}
